import api from '../../../config';

const path = 'v1/messmittel/kategorie';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
